/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrencyWithLatestRateResponseDto
 */
export interface CurrencyWithLatestRateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CurrencyWithLatestRateResponseDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyWithLatestRateResponseDto
     */
    currencyName: string;
    /**
     * 
     * @type {Date}
     * @memberof CurrencyWithLatestRateResponseDto
     */
    effectiveFromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CurrencyWithLatestRateResponseDto
     */
    effectiveToDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CurrencyWithLatestRateResponseDto
     */
    rate?: string;
}

/**
 * Check if a given object implements the CurrencyWithLatestRateResponseDto interface.
 */
export function instanceOfCurrencyWithLatestRateResponseDto(value: object): value is CurrencyWithLatestRateResponseDto {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('currencyName' in value) || value['currencyName'] === undefined) return false;
    return true;
}

export function CurrencyWithLatestRateResponseDtoFromJSON(json: any): CurrencyWithLatestRateResponseDto {
    return CurrencyWithLatestRateResponseDtoFromJSONTyped(json, false);
}

export function CurrencyWithLatestRateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyWithLatestRateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'currencyName': json['currencyName'],
        'effectiveFromDate': json['effectiveFromDate'] == null ? undefined : (new Date(json['effectiveFromDate'])),
        'effectiveToDate': json['effectiveToDate'] == null ? undefined : (new Date(json['effectiveToDate'])),
        'rate': json['rate'] == null ? undefined : json['rate'],
    };
}

export function CurrencyWithLatestRateResponseDtoToJSON(json: any): CurrencyWithLatestRateResponseDto {
    return CurrencyWithLatestRateResponseDtoToJSONTyped(json, false);
}

export function CurrencyWithLatestRateResponseDtoToJSONTyped(value?: CurrencyWithLatestRateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyCode': value['currencyCode'],
        'currencyName': value['currencyName'],
        'effectiveFromDate': value['effectiveFromDate'] == null ? undefined : ((value['effectiveFromDate']).toISOString()),
        'effectiveToDate': value['effectiveToDate'] == null ? undefined : ((value['effectiveToDate']).toISOString()),
        'rate': value['rate'],
    };
}

